/* eslint-disable no-underscore-dangle */

import React from 'react'

export type TitleCellProps = {
  cellProps: any
}

export const titleFilter = (filterItem: any, data: any) => {
  const filter = filterItem.value.toLowerCase()
  const { title } = data._original
  let result = false
  if (title && title.toLowerCase().includes(filter)) result = true
  return result
}

export const TitleCell = (props: TitleCellProps) => {
  const { cellProps } = props
  const { slug, title } = cellProps.original
  if (title) {
    return (
      <a className="bold--text" href={`/research/${slug}`}>
        {title}
      </a>
    )
  }
  return null
}
